import script from "./Wellness.vue?vue&type=script&setup=true&lang=js"
export * from "./Wellness.vue?vue&type=script&setup=true&lang=js"

import "./Wellness.vue?vue&type=style&index=0&id=3f108443&scoped=true&lang=css"

import exportComponent from "/home/runcloud1user/webapps/kurdos-vue/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f108443"]])

export default __exports__